// Convertir texto para url
export const textConvertUrl = (text: string) => {
    if (typeof text !== 'string') {
        return ''; // Devuelve una cadena vacía si `text` no es una cadena
    }
    
    return text
        .toLowerCase()
        .normalize('NFD') // Descompone los caracteres con tildes en caracteres básicos y marcas de acento separadas
        .replace(/[\u0300-\u036f]/g, '') // Elimina las marcas de acento
        .replace(/\s+/g, '-'); // Reemplaza los espacios por guiones
};


export const getDynamicProperty = (obj: any, keyPrefix: string) => {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && key.startsWith(keyPrefix)) {
            return obj[key];
        }
    }
    return null;
};
